import React from 'react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';

const SocialSharing = (props) => {
  const { url } = props;
  return (
    <>
      <span>Share with a friend: </span>
      <EmailShareButton url={url} className="mx-2">
        <EmailIcon size={32} round={true} />
      </EmailShareButton>
      <FacebookShareButton url={url} className="mx-2">
        <FacebookIcon size={32} round={true} />
      </FacebookShareButton>
      <LinkedinShareButton url={url} className="mx-2">
        <LinkedinIcon size={32} round={true} />
      </LinkedinShareButton>
      <TwitterShareButton url={url} className="mx-2">
        <TwitterIcon size={32} round={true} />
      </TwitterShareButton>
    </>
  );
};

export default SocialSharing;
